import { PaletteMode } from '@mui/material';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type State = {
  [key: string]: any;
  mode: PaletteMode;
  employeePerPage: number;
  vacationPerPage: number;
  passportRequestPerPage: number;
};
const initialState: State = { 
  mode: 'light', 
  employeePerPage: 25, 
  vacationPerPage: 25,
  passportRequestPerPage: 25,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    dark: (state) => {
      state.mode = 'dark';
    },
    light: (state) => {
      state.mode = 'light';
    },
    setEmployeePerPage: (state, action: PayloadAction<number>) => {
      state.employeePerPage = action.payload;
    },
    setVacationPerPage: (state, action: PayloadAction<number>) => {
      state.vacationPerPage = action.payload;
    },
    setPassportPerPage: (state, action: PayloadAction<number>) => {
      state.passportRequestPerPage = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { dark, light, setEmployeePerPage, setVacationPerPage, setPassportPerPage } = appSlice.actions;
export default appSlice.reducer;